export default {
    bindings: {
        'availability': '=',
        'basket': '<',
        'eventType': '<',
        'item': '=',
        'getQuantity': '&'
    },
    controller: 'availabilitySliderController',
    template: require('../views/availabilitySlider.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/page/components/availabilitySlider.component.js